export default "__VITE_ASSET__DFBB5y0c__"